<template>
  <Modal v-model="modalValue" :title="isEdit ? `编辑证书字段` : '新增证书字段'" width="700" @on-cancel="modalCancel">
    <Row>
      <Col span="20" offset="1">
        <Form ref="addForm" :model="form" :rules="rules" :label-width="100">
          <FormItem label="字段名称" prop="title">
            <Input placeholder="请输入字段名称" v-model="form.title"></Input>
          </FormItem>
          <FormItem label="状态" prop="status">
            <RadioGroup v-model="form.status">
              <Radio label="1">有效</Radio>
              <Radio label="0">无效</Radio>
            </RadioGroup>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button :loading="btnLoading" type="primary" @click="modalConfirm">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import * as apiCertificates from '@/api/certificates'
  import _ from 'lodash'
  export default {
    name: 'add-field',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      id: {
        type: [String, Number],
        default: '',
      },
    
    },
    data() {
      return {
        btnLoading:false,
        form: {
          title: '',
          status: '1',
        },
        rules: {
          title: [{ required: true, message: '字段名称不能为空', trigger: 'blur' }],
          status: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
        },
      }
    },
    methods: {
      // 获取详情
      getDetail() {
        apiCertificates.apiCertificatesFieldsDetail(this.id).then(res => {
          const {title,status} = res.data
          this.form.title = title
          this.form.status = status + ''
        })
      },
      // 提交
      modalConfirm() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            this.btnLoading = true
            if (this.isEdit) {
              let opt = _.cloneDeep(this.form)
              apiCertificates.apiCertificatesFieldsEdit(this.id,{ ...opt }).then(res => {
                this.$Message.success('编辑成功')
                this.$emit('on-success')
                this.modalCancel()
              }).finally(() => this.btnLoading = false)
            } else {
              apiCertificates.apiCertificatesFieldsAdd({ ...this.form }).then(res => {
                this.$Message.success('新增成功')
                this.$emit('on-success')
                this.modalCancel()
              }).finally(() => this.btnLoading = false)
            }
          }
        })
      },
      modalCancel() {
        this.$refs['addForm'].resetFields()
        this.$nextTick(() => {
          this.modalValue = false
        })
      },
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
    watch: {
      value(val) {
        if (val && this.isEdit) {
          this.getDetail()
        }
      },
    },
  }
</script>

